<div class="template-area__preview">
  <div class="prev-content custom-scroll-bar">
    <div class="chat-container p-2">
      <div class="chat-bubble">
        <div class="wa-template-card">
          <div class="chat-timestamp">
            <small>{{ dateHeader }}</small>
          </div>
          @if (getType() && fileUrl) {
            <div class="wa-template-card__media">
              @if (getType() === "image") {
                <label for="fileUpload" class="w-100 d-block">
                  <img
                    class="wa-template-card__image"
                    [src]="fileUrl"
                    [alt]="'rcsMessage.editor.imageAlt' | translate"
                  />
                </label>
              } @else if (getType() === "video") {
                <label
                  for="fileUpload"
                  class="w-100 d-block wa-template-card__video-wrapper"
                >
                  <video
                    class="wa-template-card__video"
                    controls
                    (click)="$event.stopPropagation()"
                  >
                    <source [src]="fileUrl" type="video/mp4" />
                    {{ "rcsMessage.preview.videoNotSupported" | translate }}
                  </video>
                </label>
              } @else if (getType() === "pdf") {
                <div
                  class="wa-template-card__pdf d-flex align-items-center gap-2"
                >
                  <i
                    class="mdi mdi-file-document-outline fs-1 text-secondary"
                  ></i>
                  <a [href]="fileUrl" target="_blank">{{
                    "rcsMessage.preview.viewPdf" | translate
                  }}</a>
                </div>
              }
            </div>
          }

          <div class="wa-template-card__body">
            @if (title) {
              <p class="wa-template-card__title mb-1">{{ title }}</p>
            }
            @if (inputText) {
              <p class="wa-template-card__subtitle mb-0">{{ inputText }}</p>
            }
          </div>

          @if (buttons && buttons.length > 0) {
            <div class="wa-template-card__actions">
              @for (button of buttons; track $index) {
                <button type="button" class="wa-template-card__button">
                  <span class="wa-template-card__button-icon">
                    @if (button.type === "openUrl") {
                      <i class="ri-earth-line fs-5"></i>
                    } @else if (button.type === "call") {
                      <i class="ri-phone-line fs-5"></i>
                    } @else if (button.type === "reply") {
                      <i class="ri-reply-line fs-5"></i>
                    }
                  </span>

                  <span class="wa-template-card__button-text">
                    {{ button.title }}
                  </span>
                </button>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
